import type ThemeService from '@efdigital/ll-xceed-v2/services/theme';
import { fn } from '@ember/helper';
import { on } from '@ember/modifier';
import { service } from '@ember/service';
import Component from '@glimmer/component';
import BsDropdown from 'ember-bootstrap/components/bs-dropdown';

function isActive(mode: string, current: string): boolean {
  return mode === current;
}

/**
 * Header control for switching between light, dark, and system colour modes.
 * The trigger icon reflects the currently-shown appearance.
 */
export default class ThemeToggle extends Component {
  @service declare theme: ThemeService;

  get triggerIcon(): string {
    return this.theme.resolvedTheme === 'dark' ? 'ph:moon' : 'ph:sun';
  }

  /** The icon alone conveys nothing to a screen reader, so name the current mode. */
  get triggerLabel(): string {
    return `Change theme (currently ${this.theme.mode})`;
  }

  <template>
    <BsDropdown as |ddm|>
      <ddm.button
        class="btn border-0 rounded-circle p-2 d-inline-flex align-items-center ll-theme-toggle"
        aria-label={{this.triggerLabel}}
        title={{this.triggerLabel}}
      >
        <iconify-icon
          inline
          icon={{this.triggerIcon}}
          class="fs-4"
          aria-hidden="true"
        />
      </ddm.button>
      <ddm.menu class="dropdown-menu-end shadow-sm" as |menu|>
        <menu.item>
          <button
            type="button"
            class="dropdown-item d-flex align-items-center gap-2
              {{if (isActive 'light' this.theme.mode) 'active'}}"
            aria-current={{if (isActive "light" this.theme.mode) "true"}}
            {{on "click" (fn this.theme.setMode "light")}}
          >
            <iconify-icon inline icon="ph:sun" aria-hidden="true" />
            Light
          </button>
        </menu.item>
        <menu.item>
          <button
            type="button"
            class="dropdown-item d-flex align-items-center gap-2
              {{if (isActive 'dark' this.theme.mode) 'active'}}"
            aria-current={{if (isActive "dark" this.theme.mode) "true"}}
            {{on "click" (fn this.theme.setMode "dark")}}
          >
            <iconify-icon inline icon="ph:moon" aria-hidden="true" />
            Dark
          </button>
        </menu.item>
        <menu.item>
          <button
            type="button"
            class="dropdown-item d-flex align-items-center gap-2
              {{if (isActive 'system' this.theme.mode) 'active'}}"
            aria-current={{if (isActive "system" this.theme.mode) "true"}}
            {{on "click" (fn this.theme.setMode "system")}}
          >
            <iconify-icon inline icon="ph:circle-half" aria-hidden="true" />
            System
          </button>
        </menu.item>
      </ddm.menu>
    </BsDropdown>
  </template>
}
